class NSSPDPYotpoReviews extends HTMLElement {

  constructor() {
    super();

    this.debug = false;
  }

  connectedCallback() {
    if (this.debug) console.log("[NSS][PDP Yotpo Reviews] Connected.");

    this.addEventListener("pdpUpdate", this.updateContent.bind(this));
  }

  updateContent(e) {
    if (this.debug) console.log("[NSS][PDP Yotpo Reviews] Updating...");
    const variantId = e.detail;
    const activeEls = this.querySelectorAll(`.nss-active`);
    activeEls.forEach((activeEl) => {
      activeEl.classList.remove(`nss-active`);
    });
    if (this.debug) console.log("[NSS][PDP Yotpo Reviews] variantId:", variantId);
    const contentEls = this.querySelectorAll(`[nss-variant-id="${variantId}"]`);
    contentEls.forEach((contentEl) => {
      contentEl.classList.add(`nss-active`);
    });

    // Update color scheme
    const prefix = "nss-scheme-";
    const classes = this.className.split(" ").filter(c => !c.startsWith(prefix));
    this.className = classes.join(" ").trim();
    this.classList.add(`nss-scheme-${variantId}`);
  }
}

let elementName = `nss-pdp-yotpo-reviews`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSPDPYotpoReviews);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`)
}